import {environment} from '../environments/environment';

export const Config = {
  siteUrl: environment.siteUrl,
  // facebookAppId: environment.facebookAppId,
  apiUrl: environment.apiUrl,
  baseUrl: environment.baseUrl,
  oneSignalId: environment.oneSignalId,
  pusher: environment.pusher,
  fakeLocation: environment.fakeLocation,
  fakeLocationData: environment.fakeLocationData,
  inAppProductsConfig: environment.inAppProductsConfig,
  admob: environment.admob,
  appVersion: environment.appVersion,
};
